import React from 'react';

const SingleDay = (props) => {
  const formatDateDisplay = () => {
    const day = props.day < 10 ? `0${props.day}` : `${props.day}`;
    const month = props.month < 10 ? `0${props.month}` : `${props.month}`;
    return `${day}.${month}`;
  };

  return (
    <div className={`card ${props.isSelected ? 'active' : ''}`}>
      <div className='card__date'>{formatDateDisplay()}</div>
      <div className='card__day-of-week'>{props.dayOfWeek}</div>
    </div>
  );
};
export default SingleDay;
